// Hook React Query para cachear las OT que alimentan el SelectorOT del modulo
// financiero. Antes de este hook, el SelectorOT pegaba al backend en cada
// keystroke (y el backend cargaba TODAS las OT sin paginar), causando >3s
// de latencia en produccion.
//
// Estrategia:
//   - Cache compartida con la key ['otsParaSelector', searchText, offset].
//   - Defaults heredados del queryClient global (5 min stale / 10 min gc).
//   - keepPreviousData: true para evitar flicker al cambiar de busqueda.
//
// El backend admite ahora { searchText, limit, offset, includeAllStatuses }
// con paginacion: cuando searchText esta vacio devuelve las ultimas `limit`
// OT ordenadas por createdAt desc (carga inicial del selector).

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { filtroOTTexto } from '../api/common';

export const OT_PARA_SELECTOR_KEY = (searchText, offset) =>
  ['otsParaSelector', (searchText || '').trim(), offset || 0];

export function useOTsParaSelector({
  searchText = '',
  limit = 50,
  offset = 0,
  enabled = true
} = {}) {
  return useQuery({
    queryKey: OT_PARA_SELECTOR_KEY(searchText, offset),
    queryFn: async () => {
      const resp = await filtroOTTexto({
        searchText: (searchText || '').trim(),
        limit,
        offset,
        includeAllStatuses: true
      });
      return resp?.data?.data || [];
    },
    // En @tanstack/react-query v5 `keepPreviousData: true` fue reemplazado por
    // `placeholderData: keepPreviousData` (sentinel). Mantiene los datos
    // previos visibles mientras llega la nueva busqueda para evitar flicker
    // en el SelectorOT.
    placeholderData: keepPreviousData,
    enabled
    // staleTime y gcTime se heredan del queryClient global (5 min / 10 min)
  });
}
